import React from "react";
import { T } from "@/locales/tr";

/**
 * ErrorBoundary global pour Papicoo.
 * Empêche qu'un crash dans une route casse toute l'application
 * (typiquement : variable undefined dans un composant page = écran blanc total).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || T("Erreur inattendue") };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[Papicoo ErrorBoundary]", error, info);
  }

  reset = () => this.setState({ hasError: false, message: "" });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="error-boundary" className="min-h-[70vh] flex items-center justify-center px-6">
        <div className="papicoo-card p-8 max-w-md text-center">
          <div className="text-5xl mb-3">🌹</div>
          <h1 className="font-display text-3xl text-[color:var(--papicoo-ink)]">{T("Salaam — petit silence.")}</h1>
          <p className="text-sm text-[color:var(--papicoo-muted)] mt-3 italic">
            {T("Papicoo a rencontré un imprévu sur cette page. Aucune donnée n'est perdue.")}
          </p>
          <p className="text-[11px] font-mono text-[color:var(--papicoo-muted)] mt-3 break-words">
            {this.state.message}
          </p>
          <div className="mt-6 flex gap-2 justify-center">
            <button
              data-testid="error-reload"
              onClick={() => window.location.reload()}
              className="px-5 py-2.5 rounded-full papicoo-btn-primary text-sm"
            >
              {T("Recharger la page")}
            </button>
            <a
              href="/"
              className="px-5 py-2.5 rounded-full bg-white border border-[color:var(--papicoo-border)] text-sm"
            >
              {T("Retour à l'accueil")}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
